import Icon from './Icon';
import { LOCALE } from '../lib/format';

// ---------- Building blocks: grouped rows with the label left and the control right ----------

export function SectionTitle({ children }) {
  return <h2 className="px-1 pb-2 pt-4 text-xs font-bold uppercase tracking-wide text-muted">{children}</h2>;
}

export function Group({ children, className = '' }) {
  return <div className={`divide-y divide-line rounded-[20px] bg-base-100 px-4 ${className}`}>{children}</div>;
}

export function Row({ label, hint, htmlFor, children }) {
  return (
    <div className="flex min-h-14 items-center justify-between gap-3 py-2">
      <label htmlFor={htmlFor} className="min-w-0">
        <span className="block text-[15px] font-medium">{label}</span>
        {hint && <span className="block text-xs text-muted">{hint}</span>}
      </label>
      <div className="flex shrink-0 items-center gap-2">{children}</div>
    </div>
  );
}

// Always shows numbers the Vietnamese way ("2.500", "86,5") and reads back only the digits typed, so the
// form keeps plain numbers ("2500", "86.5") for the API.
// `locked`: shown but not editable (targets the coach set), with a lock in the field.
export function NumberField({ id, unit, value, onChange, accent = '', decimal = false, inputRef, locked = false }) {
  const shown = value === '' ? '' : decimal ? String(value).replace('.', ',') : Number(value).toLocaleString(LOCALE);
  const parse = (text) => (decimal ? text.replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '') : text.replace(/\D/g, ''));
  return (
    <>
      <span className="relative">
        {locked && <Icon name="lock" className="pointer-events-none absolute left-2.5 top-1/2 size-3.5 -translate-y-1/2 text-muted" />}
        <input id={id} ref={inputRef} type="text" inputMode={decimal ? 'decimal' : 'numeric'} autoComplete="off" readOnly={locked}
          className={`input tabular h-11 w-24 rounded-[12px] text-right text-base font-semibold ${locked ? 'border-transparent bg-base-200' : 'border-line'} ${accent}`}
          value={shown} onChange={(e) => onChange(parse(e.target.value))} />
      </span>
      <span className="w-8 text-sm text-muted">{unit}</span>
    </>
  );
}

export function Stepper({ id, value, onChange, min = 0, max = 7 }) {
  const n = value === '' ? null : Number(value);
  const set = (next) => onChange(String(Math.min(max, Math.max(min, next))));
  const button = 'grid size-11 place-items-center rounded-[12px] border border-line bg-base-100 text-lg font-semibold disabled:opacity-40';
  return (
    <div id={id} className="flex items-center gap-3" role="group" aria-label="Buổi tập mỗi tuần">
      <button type="button" className={button} aria-label="Bớt một buổi" disabled={n == null || n <= min} onClick={() => set((n ?? min) - 1)}>−</button>
      <span className="tabular w-5 text-center text-lg font-bold" aria-live="polite">{n ?? '–'}</span>
      <button type="button" className={button} aria-label="Thêm một buổi" disabled={n != null && n >= max} onClick={() => set((n ?? 0) + 1)}>+</button>
    </div>
  );
}
